import React, { useState } from 'react';

function VisibilityButton (props) {
  const { visibility, selected, disabled, onChange } = props;
  const [openDescription, setOpenDescription] = useState(false);

  function handleMouseEnter (e) {
    if (!disabled) {
      setOpenDescription(true);
    }
  }

  function handleMouseLeave (e) {
    setOpenDescription(false);
  }

  function handleChange (e) {
    if (!disabled) {
      onChange(e);
    }
  }

  return (
    <div className="inp_item">
      <label htmlFor={`open${visibility.value}`} className="form-field" onMouseOver={handleMouseEnter} onMouseOut={handleMouseLeave}>
        <input
          type="radio" id={`open${visibility.value}`}
          className="form-radio klink-linknew" name="basicSet"
          defaultValue={visibility.value}
          checked={selected}
          onChange={handleChange}
        />
        <span className="checkbox-text">{visibility.label}</span>
      </label>
      {openDescription &&
        <div className="layer_info">
          <div className="inner_layer">
            {visibility.description}
          </div>
        </div>
      }

    </div>
  );
}

export default VisibilityButton;
